const checkboxes = document.querySelectorAll('.collection-compare-checkbox input[type="checkbox"]');
const compareButton = document.querySelector('.collection-comparable-button');
const countSpan = document.querySelector('.comparable-count');

let compareList = [];

// checkboxes.forEach(checkbox => {
//   const id = checkbox.dataset.id;
//   checkbox.checked = compareList.includes(id);
// });

checkboxes.forEach(checkbox => {
  checkbox.addEventListener('change', () => {
    const id = checkbox.dataset.id;
    const label = checkbox.closest('label');  
    const span = label.querySelector('span');
    if (checkbox.checked) {
      if (!compareList.includes(id)) {
        compareList.push(id);
      }
      span.textContent = 'Add To Compare';
    } else {
      compareList = compareList.filter(pid => pid !== id);
      span.textContent = 'Compare';
    }

    localStorage.setItem('compare_list', JSON.stringify(compareList));
    updateCompareUI();
  });
});

compareButton.addEventListener('click', () => {
  if (compareList.length < 2) {
    alert('At least 2 products are required for product comparison');
    return;
  }
  checkboxes.forEach(checkbox => {
    checkbox.checked = false;
    const span = checkbox.closest('label').querySelector('span');
    if (span) span.textContent = 'Compare';
  });
  const query = compareList.map(id => `${id}`).join('&');    
  window.location.href = `/pages/compare-velotric-ebikes?products=${query}`;
});

function updateCompareUI() {
  if (compareList.length >= 1) {
    compareButton.classList.add('active');
    countSpan.textContent = compareList.length;
  } else {
    compareButton.classList.remove('active');
    countSpan.textContent = '';
  }
}